import React from 'react';
import { Trans } from 'react-i18next';
import { GetFormatLoanAgreement } from '../../../AppUtil/AppUtil';
import { toWords } from 'number-to-words';
import { type } from 'jquery';
import { hot } from 'react-hot-loader';

const numberWithCommas = x => {
	return x.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',');
};

function formatNumberString(x) {
	let str = x.split(' ').map(x => x.charAt(0).toUpperCase() + x.slice(1));
	str = Object.values(str).join(' ');
	str = str.split(',').join(' ');

	return str;
}
function MannerPayment(props) {
	const loanObject = props.loanObject;
	const first_installment_date = GetFormatLoanAgreement(loanObject.first_installment_date);
	const end_date = GetFormatLoanAgreement(loanObject.end_date);
	const no_of_installments = loanObject.frequency !== 'LUMP_SUM' ? loanObject.no_of_installments : '';
	const emi_amount = numberWithCommas(loanObject.emi_amount.toFixed(2));
	const emi_amount_str = loanObject.emi_amount.toString();

	const emi_amount_array_centavos = emi_amount.split('.');
	const emi_amount_array = emi_amount_str.split('.');
	let emi_amount_words = emi_amount_array_centavos[1]
		? formatNumberString(toWords(emi_amount_array[0]))
		: formatNumberString(toWords(emi_amount_array[0]) + ' Pesos ');
	if (emi_amount_array_centavos[1] && emi_amount_array_centavos[1] > 0) {
		// emi_amount_words = emi_amount_words + formatNumberString(toWords(emi_amount_array[1])) + ' Centavos ';
		emi_amount_words = emi_amount_words + ' and ' + emi_amount_array_centavos[1] + '/100' + ' Pesos ';
	}

	let word_no_of_frequency = toWords(Number(no_of_installments));
	word_no_of_frequency = word_no_of_frequency.charAt(0).toUpperCase() + word_no_of_frequency.slice(1);

	const frequency =
		loanObject.frequency === 'MONTH'
			? 'MONTHLY'
			: loanObject.frequency === 'WEEK'
			? 'WEEKLY'
			: loanObject.frequency === 'TWO WEEK'
			? 'EVERY TWO WEEKS'
			: '';

	return (
		<>
			<p className="justify">
				<Trans i18nKey="loan_agreement.manner_payment">
					<strong style={{ marginRight: '2px' }}>MANNER OF PAYMENT. </strong> The Borrower has promised to pay
					back the Loan through Installment Payments or a One-Time Payment as described below:
				</Trans>
			</p>
			{loanObject.frequency !== 'LUMP_SUM' ? (
				<Trans i18nKey="loan_agreement.manner_payment_middle_new">
					<ol type="a" className="ol-list">
						<li>
							{/* <p className="justify">
								Installment Payments: Starting {{ first_installment_date }}, the BORROWER will
								installment payments the LENDER {{ no_of_installments }}
								in the amounts of {{ emi_amount_words }} (Php {{ emi_amount }} ) until the final payment
								for the Loan on {{ end_date }}. Each installment payment shall first be applied to the
								interest of the Loan and then to the Loan principal.{' '}
							</p> */}
							<p className="justify">
								Installment Payment: The BORROWER will pay the LENDER {{ word_no_of_frequency }} (
								{{ no_of_installments }}) EQUAL {{ frequency }} INSTALLMENT of {{ emi_amount_words }}{' '}
								(Php {{ emi_amount }}) starting {{ first_installment_date }} until {{ end_date }} when
								the outstanding balance is paid in full. Each installment payment shall first be applied
								to the interest of the Loan and then to the Loan principal.
							</p>
						</li>
					</ol>{' '}
				</Trans>
			) : (
				<Trans i18nKey="loan_agreement.manner_payment_middle_one_payment">
					<ol type="a" className="ol-list">
						<li>
							<p className="justify">
								One-Time Payment: The Borrower shall pay the Lender the full amount of the Loan plus
								interest on or before {{ first_installment_date }}.
							</p>
						</li>
					</ol>
				</Trans>
			)}

			<Trans i18nKey="loan_agreement.manner_payment_bottom_new">
				{/* <p className="justify">The BORROWER cannot change the manner of payment after he has chosen it.</p> */}
				<p className="justify">The BORROWER cannot change the manner of payment after it has been chosen.</p>
				<p className="justify">
					The BORROWER must pay the LENDER via LendAmi wallet unless the LENDER tells the BORROWER to pay via
					other options.
				</p>
			</Trans>
		</>
	);
}

export default hot(module)(MannerPayment);
